import { Keys } from '../types';

const keys: Keys = {};

export default keys;
